import { create } from 'zustand';
import _ from 'lodash';

interface initDataState {
  param: any;
  bindParam: any;
  result: any;
  initPayload: any;
  payload: any;
  bind: (result: { data: any }) => void;
  bindPayload: (payload: { data: any }) => void;
}

export const initDonationPayload = {
  name: '', //사용자명
  acct_year: '', //연말정산   년도
  co_cd: '', //회사코드
  co_id: '', //사번
  in_data_seqid: '', //입력데이터 sequence
  family_seqid: 0, //부양가족 sequence
  co_num: '', //사업자번호
  trade_nm: '', //기부처
  cnt: 0, //건수
  amt: 0, // 기부금(일반)
  htx_amt: 0, //기부금(국세청)
  data_type: '', //구분(기부유형)
  is_co_support: '', //회사지원기부금 여부
  is_htx_pdf: 0, //국세청 PDF 자료여부
  encourage_req_amt: 0, //기부장려금 신청금액
  donate_year: '', //기부년도
  total_amt: 0, //기부금액
  minus_amt: 0, //전년도까지 적용금액
};

/**
  신용카드
**/
export const donationDataStore = create<initDataState>(set => ({
  param: { initialSeq: 0 },
  bindParam: (bind: any) =>
    set(state => ({
      ...state,
      param: { ...state.param, ...bind },
    })),
  result: [],
  bind: (data: any) =>
    set(state => ({
      ...state,
      result: { ...state.result, ...data },
    })),
  initPayload: initDonationPayload,
  payload: _.cloneDeep(initDonationPayload),
  bindPayload: (data: any) =>
    set(state => ({
      ...state,
      payload: { ...state.payload, ...data },
    })),
}));
